import DataApi from './DataApi';

class SessionSettingApi extends DataApi {
  constructor() {
    super('session-setting');
  }

  fetchSettings() {
    return this.get('');
  }

  updateSettings(settings) {
    return this.put('', { settings });
  }
}

export default SessionSettingApi;
